// extracted by mini-css-extract-plugin
module.exports =  {"overlay":"xNjradh","content":"DGIiLfA","mobile-full-screen":"ilLCHti","mobileFullScreen":"ilLCHti"};